export default function CompactDisclaimer() {
  return (
    <div className="text-muted small mt-2" style={{ fontSize: "0.75rem" }}>
      AI responses may be inaccurate. Not medical, legal, or financial advice.
    </div>
  );
}